import styled, { css } from 'styled-components'
import { colors, sizes } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { USERS_TABLE_WRAPPER_ID } from '../entity-users-management/UserTable/UsersTable'

export const StyledSidebar = styled.nav`
  display: flex;
  z-index: 999;
  flex-direction: column;
  width: ${(props: { $minimize: boolean }) => (props.$minimize ? 60 : 250)}px;
  height: 100vh;
  background-color: ${colors.ultraLightGray};
  position: fixed;
  top: 0px;
  padding-top: 80px;
  z-index: 10;
  overflow-y: auto;
  overflow-x: hidden;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    padding-top: 0px;
    top: 70px;
    height: calc(100vh - 70px);
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    body:has(#${USERS_TABLE_WRAPPER_ID}) & {
      display: none;
    }
  }
`

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`

export const SidebarFooter = styled.div`
  margin-top: auto;
  padding: 8px;
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;
`

const activeStyles = `
  color: ${colors.darkGray};

  &:before {
    background-color: ${tokens.colors.primary};
  }

  span {
    color: ${tokens.colors.primary};
  }
`

export const SidebarItem = styled.div`
  ${({ active, $minimize }: { active?: boolean; $minimize?: boolean }) => css`
    color: ${colors.gray4};
    text-transform: uppercase;
    cursor: pointer;
    font-size: ${sizes.smallText}px;
    font-weight: bold;
    padding: ${$minimize ? `0 16px 10px` : `0 25px 10px 25px`};
    display: flex;
    align-items: center;
    transition: color 150ms ease;

    &:before {
      content: '';
      display: inline-block;
      height: 40px;
      width: 3px;
      background-color: ${colors.ultraLightGray};
      position: relative;
      left: ${$minimize ? `-16px` : `-25px`};

      transition: background-color 150ms ease;
    }

    span {
      color: ${colors.gray4};
      transition: color 150ms ease;
      ${!$minimize && `margin-right: 10px;`};
      width: 24px;
      text-align: center;
    }

    &:hover {
      ${activeStyles};
    }

    ${active && activeStyles};
  `};
`

export const Logo = styled.a`
  padding: ${(props: { $minimize?: boolean }) =>
    props.$minimize ? `25px 10px` : `25px`};
`
export const MinimizeMenu = styled.div`
  cursor: pointer;
  position: absolute;
  left: ${(props: { $minimize?: boolean }) => (props.$minimize ? 60 : 250)}px;
  top: 38px;
  background-color: ${colors.ultraLightGray};

  &:hover {
    span {
      color: ${tokens.colors.primary};
    }
  }
`
